import { Company } from '@/models/Company'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<Company>(Company, {
	namespaced: true
})
